module.exports = __webpack_public_path__ + "static/utah-shakespeare-festival-d96a68e338c1d69632541456562373a5.jpg";